import axios from 'axios';
import JSONbig from 'json-bigint';
import { appendToFormData } from '../util/util';

function hasFiles(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return Object.values(obj).some(v =>
        v instanceof File || v instanceof Blob || (typeof v === 'object' && v !== null && hasFiles(v))
    );
}

export default function api({ method = "get", action = "", token, data = {}, params = {}, headers = {}, signal, responseType, timeout }) {
    const needsMultipart = data instanceof FormData || hasFiles(data);
    let requestData = data;

    if (needsMultipart && !(data instanceof FormData)) {
        requestData = new FormData();
        appendToFormData(requestData, data);
        if (!['get', 'post'].includes(method.toLowerCase())) {
            requestData.append('_method', method.toUpperCase());
            method = 'post';
        }
    } else if (data instanceof FormData && !['get', 'post'].includes(method.toLowerCase())) {
        requestData.append('_method', method.toUpperCase());
        method = 'post';
    }

    const isFormData = requestData instanceof FormData;
    var tokenObj = token ? { 'Authorization': `Bearer ${token}` } : {};
    var paramsObj = Object.keys(params).length > 0 ? { params } : null;

    return axios({
        method,
        url: process.env.REACT_APP_API_URL + action,
        data: requestData,
        headers: {
            'Accept': 'application/json',
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            ...tokenObj,
            // tela do front que originou a requisição -> log_operacao.link_acao (auditoria)
            'X-Front-Url': typeof window !== 'undefined' ? window.location.href : '',
            // O cargo que o admin simula no topo da tela (`NavBar`): o back usa no lugar do dele, só para o admin.
            ...(localStorage.getItem('perfilReal') ? { 'X-Mock-Perfil': localStorage.getItem('perfil') } : {}),
            ...headers
        },
        // resposta binária (blob/arraybuffer): axios entrega o binário cru, sem o parse JSON.
        // Sem responseType, mantém o parse JSONbig padrão (comportamento inalterado p/ todos os call sites).
        ...(responseType
            ? { responseType }
            : {
                transformResponse: [function (data) {
                    if (data === null || data === undefined || data === '') return data;
                    try {
                        return JSONbig({ storeAsString: true }).parse(data);
                    } catch (e) {
                        return data;
                    }
                }]
            }),
        ...paramsObj,
        // Tempo limite só para quem pedir (Salvar do orçamento, 16/10); o resto segue sem.
        ...(timeout ? { timeout } : {}),
        signal
    });
}
